export default {
	type: 'object',
	properties: {
		recordId: { type: 'string' },
	},
	required: [],
	additionalProperties: false,
}
